import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "animate.css";
import axios from "axios";

function Banner() {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchBanners = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API}website/banner_list`,
      );

      if (data?.result) {
        setBanners(data.data);
      } else {
        setError("No banner found");
      }
    } catch (err) {
      setError("Failed to load banners");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);
  return (
    <div>
      <div className="main-banner-section section-mt section-mb">
        <div className="container-fluid px-0">
          <div className="row mx-0">
           <div className="col-12 px-0">
  <a href="/shop" className="banner-box-animation">
    <img
      className="bannerimg"
      src={`${process.env.REACT_APP_API}uploads/${banners?.[2]?.banner_image}`}
      height={400}
      style={{ width: "100%", display: "block" }}
      alt="Banner"
      onError={(e) => (e.target.src = "/fallback-banner.jpg")}
    />
  </a>
</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Banner;

//  <div className="col-12 px-0">
//           <a href="/shop" className="banner-box-animation">
//             <img
//               height={400}
//               style={{
//                 width: "100%",
//                 display: "block"
//               }}
//               src="assets/images/banner/img3.jpg"

//               alt="images_not_found"
//             />
//           </a>
//         </div>
